"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmHubApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var CrmHubApi = /** @class */ (function (_super) {
    __extends(CrmHubApi, _super);
    function CrmHubApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CrmHubApi.prototype.crmHubCrmHubConfigsGetCrmHubConfigPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/CrmHub/CrmHubConfigs/GetCrmHubConfig',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubCrmHubConfigsUpdateCrmHubConfigPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerUpdateCrmHubConfigRequest = _a.travisBackendControllersSleekflowControllersCrmHubControllerUpdateCrmHubConfigRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/CrmHubConfigs/UpdateCrmHubConfig',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerUpdateCrmHubConfigRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubDeleteProviderConnectionPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerDeleteProviderConnectionInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerDeleteProviderConnectionInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/DeleteProviderConnection',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerDeleteProviderConnectionInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetContactListByCampaignIdPost = function (_a, opts) {
        var campaignId = _a.campaignId, newContactListName = _a.newContactListName;
        var headers = {};
        var query = {};
        if (campaignId != null) {
            query['campaignId'] = campaignId;
        }
        if (newContactListName != null) {
            query['newContactListName'] = newContactListName;
        }
        return this.request({
            url: '/CrmHub/GetContactListByCampaignId',
            method: 'POST',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetConversationByObjectPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetConversationByObjectInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetConversationByObjectInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetConversationByObject',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetConversationByObjectInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetObjectsByIdentitiesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsByIdentitiesInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsByIdentitiesInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetObjectsByIdentities',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsByIdentitiesInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetObjectsCountPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsCountInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsCountInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetObjectsCount',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsCountInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetObjectsCountV2Post = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsCountV2Input = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsCountV2Input;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetObjectsCountV2',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsCountV2Input,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetObjectsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetObjects',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetObjectsV2Post = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsV2Input = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsV2Input;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetObjectsV2',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetObjectsV2Input,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderConfigPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetProviderConfigInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetProviderConfigInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetProviderConfig',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetProviderConfigInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderConfigsPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/CrmHub/GetProviderConfigs',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderConnectionsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetProviderConnectionsInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetProviderConnectionsInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetProviderConnections',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetProviderConnectionsInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderObjectDirectRefUrlPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetProviderObjectDirectRefUrlInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetProviderObjectDirectRefUrlInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetProviderObjectDirectRefUrl',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetProviderObjectDirectRefUrlInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderObjectsCountPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetProviderObjectsCountInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetProviderObjectsCountInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetProviderObjectsCount',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetProviderObjectsCountInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderSubscriptionsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetProviderSubscriptionsInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetProviderSubscriptionsInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetProviderSubscriptions',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetProviderSubscriptionsInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderSupportedTypesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetProviderSupportedTypesInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetProviderSupportedTypesInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetProviderSupportedTypes',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetProviderSupportedTypesInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderSyncObjectsProgressPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetProviderSyncObjectsProgressInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetProviderSyncObjectsProgressInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetProviderSyncObjectsProgress',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetProviderSyncObjectsProgressInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderTypeFieldsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetProviderTypeFieldsInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetProviderTypeFieldsInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetProviderTypeFields',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetProviderTypeFieldsInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProviderTypeFieldsV2Post = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetProviderTypeFieldsV2Input = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetProviderTypeFieldsV2Input;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetProviderTypeFieldsV2',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetProviderTypeFieldsV2Input,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetProvidersPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/CrmHub/GetProviders',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetTypeFieldValuesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetTypeFieldValuesInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetTypeFieldValuesInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetTypeFieldValues',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetTypeFieldValuesInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetTypeFieldsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetTypeFieldsInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetTypeFieldsInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetTypeFields',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetTypeFieldsInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetUnifyRulesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerGetUnifyRulesInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerGetUnifyRulesInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/GetUnifyRules',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerGetUnifyRulesInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubGetUserMappingsPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/CrmHub/GetUserMappings',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubInitProviderPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerInitProviderInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerInitProviderInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/InitProvider',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerInitProviderInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubInitProviderTypeSyncPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerInitProviderTypeSyncInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerInitProviderTypeSyncInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/InitProviderTypeSync',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerInitProviderTypeSyncInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubInitProviderTypesSyncPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerInitProviderTypesSyncInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerInitProviderTypesSyncInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/InitProviderTypesSync',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerInitProviderTypesSyncInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubInitProviderV2Post = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerInitProviderV2Input = _a.travisBackendControllersSleekflowControllersCrmHubControllerInitProviderV2Input;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/InitProviderV2',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerInitProviderV2Input,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubPreviewObjectsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerPreviewObjectsInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerPreviewObjectsInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/PreviewObjects',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerPreviewObjectsInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubPropagateObjectUpdateToProviderPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerPropagateObjectUpdateToProviderInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerPropagateObjectUpdateToProviderInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/PropagateObjectUpdateToProvider',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerPropagateObjectUpdateToProviderInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubReInitProviderConnectionPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerReInitProviderConnectionInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerReInitProviderConnectionInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/ReInitProviderConnection',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerReInitProviderConnectionInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubRenameProviderConnectionPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerRenameProviderConnectionInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerRenameProviderConnectionInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/RenameProviderConnection',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerRenameProviderConnectionInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubSyncObjectsToCrmHubPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/CrmHub/SyncObjectsToCrmHub',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubTriggerProviderSyncObjectsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerTriggerProviderSyncObjectsInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerTriggerProviderSyncObjectsInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/TriggerProviderSyncObjects',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerTriggerProviderSyncObjectsInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubUpdateUserMappingsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerUpdateUserMappingsInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerUpdateUserMappingsInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/UpdateUserMappings',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerUpdateUserMappingsInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubUpsertUnifyRulesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCrmHubControllerUpsertUnifyRulesInput = _a.travisBackendControllersSleekflowControllersCrmHubControllerUpsertUnifyRulesInput;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/UpsertUnifyRules',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCrmHubControllerUpsertUnifyRulesInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubWebhookOnEntityCreatedPost = function (_a, opts) {
        var travisBackendSleekflowCrmHubDomainModelsOnEntityCreatedWebhookPayload = _a.travisBackendSleekflowCrmHubDomainModelsOnEntityCreatedWebhookPayload;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/WebhookOnEntityCreated',
            method: 'POST',
            headers: headers,
            body: travisBackendSleekflowCrmHubDomainModelsOnEntityCreatedWebhookPayload,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CrmHubApi.prototype.crmHubWebhookOnEntityFieldsChangedPost = function (_a, opts) {
        var travisBackendSleekflowCrmHubDomainModelsOnEntityFieldsChangedWebhookPayload = _a.travisBackendSleekflowCrmHubDomainModelsOnEntityFieldsChangedWebhookPayload;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CrmHub/WebhookOnEntityFieldsChanged',
            method: 'POST',
            headers: headers,
            body: travisBackendSleekflowCrmHubDomainModelsOnEntityFieldsChangedWebhookPayload,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return CrmHubApi;
}(runtime_1.BaseAPI));
exports.CrmHubApi = CrmHubApi;
